export const FRONTEND_PAGES = [
  { path: '/', name: 'Anasayfa', category: 'Genel', component: 'EnhancedHomePage' },
  { path: '/hakkimizda', name: 'Hakkımızda', category: 'Kurumsal', component: 'AboutPage' },
  { path: '/iletisim', name: 'İletişim', category: 'Kurumsal', component: 'ContactPage' },
  { path: '/eticaret', name: 'E-Ticaret', category: 'Hizmetler', component: 'EcommercePage' },
  { path: '/profesyonel-eticaret', name: 'Profesyonel E-Ticaret', category: 'Hizmetler', component: 'ProfessionalEcommercePage' },
  { path: '/b2b-eticaret', name: 'B2B E-Ticaret', category: 'Hizmetler', component: 'B2BEcommercePage' },
  { path: '/sinirsiz-hosting', name: 'Sınırsız Hosting', category: 'Hosting', component: 'HostingPage' },
  { path: '/bayi-hosting', name: 'Bayi Hosting', category: 'Hosting', component: 'ResellerHostingPage' },
  { path: '/wordpress-hosting', name: 'WordPress Hosting', category: 'Hosting', component: 'WordPressHostingPage' },
  { path: '/eticaret-hosting', name: 'E-Ticaret Hosting', category: 'Hosting', component: 'EcommerceHostingPage' },
  { path: '/alan-adi', name: 'Alan Adı', category: 'Domain', component: 'DomainPage' },
  { path: '/vps-sunucu', name: 'VPS Sunucu', category: 'Sunucu', component: 'VPSServerPage' },
  { path: '/vds-sunucu', name: 'VDS Sunucu', category: 'Sunucu', component: 'VDSServerPage' },
  { path: '/kurumsal-sunucu', name: 'Kurumsal Sunucu', category: 'Sunucu', component: 'CorporateServerPage' },
  { path: '/ssl-sertifikasi', name: 'SSL Sertifikası', category: 'Güvenlik', component: 'SSLPage' },
  { path: '/marka-tescil-sorgulama', name: 'Marka Tescil', category: 'Hizmetler', component: 'MarkaTescilPage' },
  { path: '/kolay-site', name: 'Kolay Site', category: 'Hizmetler', component: 'KolaySitePage' },
  { path: '/hazir-web-sitesi-tasarimlari', name: 'Web Site Şablonları', category: 'Hizmetler', component: 'WebsiteTemplatesPage' },
  { path: '/projeler', name: 'Projeler', category: 'Genel', component: 'ProjectsPage' },
  { path: '/projeler-katalog', name: 'Proje Kataloğu', category: 'Genel', component: 'ProjectsCatalogPage' },
  { path: '/blog', name: 'Blog', category: 'İçerik', component: 'BlogPage' },
  { path: '/egitim', name: 'Eğitim', category: 'İçerik', component: 'EducationPage' },
  { path: '/yapay-zeka', name: 'Yapay Zeka (Gogi AI)', category: 'Hizmetler', component: 'GogiAIPage' },
  { path: '/sikca-sorulan-sorular', name: 'SSS', category: 'Genel', component: 'FAQPageFull' },
  { path: '/seo-hizmetleri', name: 'SEO Hizmetleri', category: 'Hizmetler', component: 'SeoServicesPage' },
  { path: '/reklam-hizmetleri', name: 'Reklam Hizmetleri', category: 'Hizmetler', component: 'AdvertisingServicesPage' },
  { path: '/marka-tasarim-hizmeti', name: 'Marka Tasarım Hizmeti', category: 'Hizmetler', component: 'BrandDesignServicesPage' },
  { path: '/dijital-tasarimlar', name: 'Dijital Tasarımlar', category: 'Hizmetler', component: 'DigitalDesignsPage' },
  { path: '/basili-materyaller', name: 'Basılı Materyaller', category: 'Hizmetler', component: 'PrintMaterialsPage' },
  { path: '/web-sitesi-tasarimlari', name: 'Web Sitesi Tasarımları', category: 'Hizmetler', component: 'WebDesignTemplatesPage' },
  { path: '/kurumsal-web-sitesi', name: 'Kurumsal Web Sitesi', category: 'Hizmetler', component: 'CorporateWebsitePage' },
  { path: '/referanslar', name: 'Referanslar', category: 'Genel', component: 'ReferencesPage' },
  { path: '/hizmetler', name: 'Hizmetler', category: 'Hizmetler', component: 'AllServicesPage' },
  { path: '/pazarlama-hizmetleri', name: 'Pazarlama Hizmetleri', category: 'Hizmetler', component: 'MarketingServicesPage' },
  { path: '/cerez-politikasi', name: 'Çerez Politikası', category: 'Yasal', component: 'CookiePolicyPage' },
  { path: '/kvkk', name: 'KVKK', category: 'Yasal', component: 'KvkkPage' },
  { path: '/whatsapp-crm', name: 'WhatsApp CRM', category: 'Hizmetler', component: 'WhatsAppCRM' },
  { path: '/kayit', name: 'Kayıt', category: 'Kullanıcı', component: 'SignupPage' },
  { path: '/giris', name: 'Giriş', category: 'Kullanıcı', component: 'LoginPage' },
  { path: '/hesabim', name: 'Hesabım', category: 'Kullanıcı', component: 'UserDashboard' },
  { path: '/profil', name: 'Profil', category: 'Kullanıcı', component: 'UserDashboard' },
  { path: '/arama', name: 'Arama', category: 'Genel', component: 'SearchResultsPage' },
  { path: '/odeme-basarili', name: 'Ödeme Başarılı', category: 'Genel', component: 'PaymentSuccessPage' },
  { path: '/ssl/ssl-sertifikasi', name: 'SSL Sertifikası (Alt Yol)', category: 'Güvenlik', component: 'SSLCertificatesPage' }
];

export const PAGE_SLUG_MAP = {
  '/': 'anasayfa',
  '/yapay-zeka': 'yapay-zeka',
  '/hakkimizda': 'hakkimizda',
  '/iletisim': 'iletisim',
  '/eticaret': 'eticaret',
  '/profesyonel-eticaret': 'profesyonel-eticaret',
  '/b2b-eticaret': 'b2b-eticaret',
  '/eticaret-hosting': 'eticaret-hosting',
  '/sinirsiz-hosting': 'sinirsiz-hosting',
  '/bayi-hosting': 'bayi-hosting',
  '/wordpress-hosting': 'wordpress-hosting',
  '/alan-adi': 'alan-adi',
  '/vps-sunucu': 'vps-sunucu',
  '/vds-sunucu': 'vds-sunucu',
  '/kurumsal-sunucu': 'kurumsal-sunucu',
  '/ssl-sertifikasi': 'ssl-sertifikasi',
  '/marka-tescil-sorgulama': 'marka-tescil-sorgulama',
  '/kolay-site': 'kolay-site',
  '/seo-hizmetleri': 'seo-hizmetleri',
  '/reklam-hizmetleri': 'reklam-hizmetleri',
  '/marka-tasarim-hizmeti': 'marka-tasarim-hizmeti',
  '/dijital-tasarimlar': 'dijital-tasarimlar',
  '/basili-materyaller': 'basili-materyaller',
  '/web-sitesi-tasarimlari': 'web-sitesi-tasarimlari',
  '/kurumsal-web-sitesi': 'kurumsal-web-sitesi',
  '/referanslar': 'referanslar',
  '/hizmetler': 'hizmetler',
  '/pazarlama-hizmetleri': 'pazarlama-hizmetleri',
  '/cerez-politikasi': 'cerez-politikasi',
  '/kvkk': 'kvkk',
  '/whatsapp-crm': 'whatsapp-crm',
  '/kayit': 'kayit',
  '/giris': 'giris',
  '/hesabim': 'hesabim',
  '/profil': 'profil',
  '/arama': 'arama',
  '/odeme-basarili': 'odeme-basarili',
  '/ssl/ssl-sertifikasi': 'ssl-sertifikasi'
};

